import { Device, FetchUsersRequest, FetchUsersResponse, FullUser, OrgInfo, Package, User } from '../typings';
import { ApiContextType } from '../api-context';

export const fetchUsers = (api: ApiContextType, request: FetchUsersRequest): Promise<FetchUsersResponse> => {
    return api.post(`/users`, request)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const fetchUserDevices = (api: ApiContextType, id: number): Promise<Device[]> => {
    return api.get(`/user/${id}/devices`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const fetchUser = (api: ApiContextType, id: number): Promise<FullUser> => {
    return api.get(`/user/${id}`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const updateUser = (api: ApiContextType, id: number, user: FullUser): Promise<void> => {
    return api.post(`/user/${id}`, user)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

export const createUser = (api: ApiContextType, email: string): Promise<void> => {
    return api.put(`/user`, email)
        .then(res => {
            if (res.status === 200 || res.status === 204) {
                return Promise.resolve();
            }
            return res.text().then(t => Promise.reject(t));
        });
};

export const removeUser = (api: ApiContextType, id: number): Promise<void> => {
    return api.del(`/user/${id}`)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

export const getAvailablePackages = (api: ApiContextType): Promise<Package[]> => {
    return api.get(`/user/articles`)
        .then(res => {
            if (res.status === 200 || res.status === 204) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};


export const addPackage = (api: ApiContextType, userId: number, packageId: number): Promise<void> => {
    return api.put(`/user/${userId}/article/${packageId}`)
        .then(res => {
            if (res.status === 200 || res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

